import { TeamsContent } from "@/components/players/TeamsContent";

export default function TeamsPage() {
  return (
    <div className="space-y-6">
      <TeamsContent />
    </div>
  );
}

